<template>
    <div>
        <div class="bg">
            <div class="btn">
                <div @click="jumpTodtail">开</div>
            </div>
        </div>
    </div>
</template>

<script>
import {doGetWxAuth, doGetActClick, getActClickList} from "./api";
export default {
    data() {
        return {
            code: "",
            userInfo: {},
            helerInfo: {}
        };
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (!localStorage.getItem("wxCode")) {
                if (window.location.href.indexOf("code") != -1) {
                    vm.code = vm.getCode();
                    localStorage.setItem("wxCode", vm.code);
                    vm.getWxInfo();
                } else {
                    let locat = "http://weixin.96299.com.cn/appAuth.html";
                    window.location.href =
                        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx56c9e7fe0caa9826&redirect_uri=" +
                        encodeURIComponent(locat) +
                        "&response_type=code&scope=snsapi_userinfo#wechat_redirect";
                }
            } else {
                vm.getWxInfo();
            }
        });
    },
    // beforeRouteLeave(to, from, next) {
    //     // ...
    //     next(vm => {
    //         localStorage.removeItem("wxCode");
    //     });
    // },
    methods: {
        async getWxInfo() {
            this.$Indicator.open({
                spinnerType: "fading-circle"
            });
            let data = await doGetWxAuth({
                code: localStorage.getItem("wxCode"),
                type: "wx"
            });
            if (!data.hasError) {
                this.userInfo = data.info;
            }
            this.helerInfo = await getActClickList({
                share_code: localStorage.getItem("shareCode"),
                wxCode: localStorage.getItem("wxCode")
            });
            if (!this.helerInfo.hasError && this.helerInfo.hasClick) {
                this.$router.push({
                    name: "couponActivity",
                    params: {
                        isRegister: this.helerInfo.isRegister,
                        userInfo: this.helerInfo.userInfo,
                        hasRewards: this.helerInfo.hasRewards,
                        shareInfo: this.helerInfo.shareInfo
                    }
                });
            }
            this.$Indicator.close();
        },
        getCode() {
            var vars = window.location.href.split("?")[1];
            var pair = vars.split("=");
            return pair[1];
        },
        jumpTodtail() {
            this.$Indicator.open({
                spinnerType: "fading-circle"
            });
            setTimeout(async () => {
                let share_code, wxCode;
                wxCode = localStorage.getItem("wxCode");
                if (this.$route.params.shareCode) {
                    share_code = this.$route.params.shareCode;
                } else {
                    share_code = localStorage.getItem("shareCode");
                }
                let data = await doGetActClick({
                    share_code,
                    wxCode
                });
                if (!data.hasError) {
                    this.$router.push({
                        name: "couponActivity",
                        params: {
                            isRegister: this.helerInfo.isRegister,
                            userInfo: this.helerInfo.userInfo,
                            hasRewards: this.helerInfo.hasRewards,
                            wxCode
                        }
                    });
                }
                this.$Indicator.close();
            }, 1000);
        }
    }
};
</script>
<style lang="scss">
.bg {
    width: 100vw;
    height: 100vh;
    background: url(../../assets/image/openBg.png) 100% 100% no-repeat;
    background-size: cover;
    position: relative;
}
.btn {
    width: 192px;
    height: 267px;
    position: relative;
    top: 163px;
    margin-left: 50%;
    transform: translateX(-50%);
    background: url(../../assets/image/redBag.png) no-repeat;
    background-size: cover;
    div {
        position: absolute;
        top: 40px;
        font-size: 44px;
        color: rgba(239, 54, 25, 1);
        font-weight: bold;
        margin-left: 52%;
        transform: translateX(-50%);
    }
}
</style>